$('document').ready(function () {
  // Page Loader
  $('.page-loader').fadeOut();

  // Hamburger
  $('.hamburger').on('click', function () {
    $('body').toggleClass('nav-active');

    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', 'true');
      $(this).addClass('is-active');
    } else {
      $(this).attr('aria-expanded', 'false');
      $(this).removeClass('is-active');
    }
  });

  /*
  $('.main-navigation .menu-item-has-children > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('active')) {
      $(this).parent().find('.sub-menu').hide();
      $(this).parent().removeClass('active');
    } else {
      $('.main-navigation .menu-item-has-children').find('.sub-menu').hide();
      $('.main-navigation .menu-item-has-children').removeClass('active');
      $(this).parent().find('.sub-menu').show();
      $(this).parent().addClass('active');
    }
  });
  */

  $('.mobile-nav-box .menu-item-has-children > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('active')) {
      $(this).parent().find('.sub-menu').hide();
      $(this).parent().removeClass('active');
    } else {
      $('.mobile-nav-box .menu-item-has-children > a').parent().find('.sub-menu').hide();
      $('.mobile-nav-box .menu-item-has-children').removeClass('active');
      $(this).parent().find('.sub-menu').show();
      $(this).parent().addClass('active');
    }

  });

  // Floating Labels for CF7
  //https://webdesign.tutsplus.com/tutorials/floating-labels-for-contact-form-7--cms-36327
  const formsWithAnimatedLabels = document.querySelectorAll(".form-with-animated-labels");
  const focusedClass = "focused";

  for (const form of formsWithAnimatedLabels) {
    const formControls = form.querySelectorAll(
      '[type="text"], [type="email"], [type="tel"], textarea'
    );
    for (const formControl of formControls) {
      formControl.addEventListener("focus", function () {
        this.parentElement.nextElementSibling.classList.add(focusedClass);
      });

      formControl.addEventListener("blur", function () {
        if (!this.value) {
          this.parentElement.nextElementSibling.classList.remove(focusedClass);
        }
      });
    }

    form.parentElement.addEventListener("wpcf7mailsent", function () {
      const labels = document.querySelectorAll(".focused");
      for (const label of labels) {
        label.classList.remove(focusedClass);
      }
    });
  }

  // Parallax
  // Use 'data-speed' 0.0 to 1.0 for distance
  // Use 'data-direction' up or down for direction
  let parallaxElems = $("[data-speed]");

  $(parallaxElems).each(function () {
    let directionInit;
    let directionFinal;

    if (this.getAttribute("data-direction") == "up") {
      directionInit = -1;
      directionFinal = 1;
    } else if (this.getAttribute("data-direction") == "down") {
      directionInit = 1;
      directionFinal = -1;
    }

    gsap.to(this, {
      y: (i, el) =>
        directionFinal *
        parseFloat(el.getAttribute("data-speed")) *
        this.offsetHeight,
      ease: "none",
      scrollTrigger: {
        trigger: this,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        scrub: 0,
        markers: false
      }
    });
  });

  // BG Parallax
  let getRatio = el => window.innerHeight / (window.innerHeight + el.offsetHeight);

  gsap.utils.toArray(".bg-parallax").forEach((bgDiv, i) => {
    gsap.fromTo(bgDiv, {
      backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio(bgDiv)}px` : "50% 0px"
    }, {
      backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio(bgDiv))}px`,
      ease: "none",
      scrollTrigger: {
        trigger: bgDiv,
        start: () => i ? "top bottom" : "top top",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  });

  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 100, event);
    };
  }

  // Text Reveal
  function textReveal(text) {
    let split = new SplitType(text);
    gsap.utils.toArray(text).forEach((elem) => {
      let line = elem.querySelectorAll(".word");
      ScrollTrigger.create({
        trigger: elem,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        scrub: 0,
        markers: false,
        onEnter: () => gsap.fromTo(line,
          { y: 100, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, stagger: 0.1, duration: .25 }),
        onEnterBack: () => gsap.fromTo(line,
          { y: 100, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, stagger: 0.1, duration: .25 }),
      });
    });
  }
  textReveal('.text-reveal');

  window.addEventListener('resize', debounce(function (e) {
    textReveal('.text-reveal');
  }));

  // Block: App Features
  if ($('block_app_features')) {
    $('.app-feature').on('mouseenter', function () {
      let featureNumber = $(this).data('feature');
      let imageTarget = $('.app-screenshot-' + featureNumber);

      $('.app-screenshot').find('img').addClass('opacity-0');
      $(imageTarget).find('img').removeClass('opacity-0');

      $('.app-feature').removeClass('active');
      $(this).addClass('active');
    });
  }

  setTimeout(function () {
    $(".hs_select_duration_of_meeting .input label span").on("click", function () {

      if ($(this).text() == 'Discovery') {
        $('.demo-section').hide();
        $('.discovery-section').show();
      }
      if ($(this).text() == 'Demo') {
        $('.discovery-section').hide();
        $('.demo-section').show();
      }
      $(".hs_select_duration_of_meeting .input label").removeClass('active');
      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
      } else {
        $(this).parent().addClass('active');
      }
    });
  }, 500);

  $(".accordion-button").on("click", function () {
    // recalculate owl height
    setInterval(function () {
      $('.carousel-plans').trigger('refresh.owl.carousel');
    }, 1000);
  });

  $('a.btn').click(function (e) {
    if ($(this).attr("href") == "#download-guide") {

      e.preventDefault();
      if ($(".wrapper").hasClass("header-on")) {

        $('html,body').animate({
          scrollTop: $(".download-guide-form .row > div:last-child").offset().top - 90
        }, 300);
      } else {
        $('html,body').animate({
          scrollTop: $(".download-guide-form .row > div:last-child").offset().top
        }, 300);
      }

    }
  });

  // Colleague Lifecycle
  $(".colleague-lifecycle-diagram path").hover(function () {
    $(this).parent().addClass("hover");
    $(this).addClass("active");
    var feature = $(this).data('feature');
    $('.lifecycle-stage').removeClass('focus');
    $('.lifecycle-stage[data-feature="' + feature + '"]').addClass('focus');
  }, function () {
    $(this).parent().removeClass("hover");
    $(this).removeClass("active");
    $('.lifecycle-stage').removeClass('focus');
  });

  $(".lifecycle-stage").hover(function () {
    $(this).addClass("focus");
    $('.colleague-lifecycle-diagram').addClass("hover");
    var feature = $(this).data('feature');
    $('.colleague-lifecycle-diagram path').removeClass('active');
    $('.colleague-lifecycle-diagram path[data-feature="' + feature + '"]').addClass('active');
  }, function () {
    $('.colleague-lifecycle-diagram').removeClass("hover");
    $(this).removeClass("focus");
    $('.colleague-lifecycle-diagram path').removeClass('active');
  });

});

$(window).on('load', function () {
  // Wait for all resources to load, then check for the hash in the URL
  if (window.location.hash) {
    var hash = window.location.hash; // Get the hash from the URL
    var targetElement = $(hash); // Find the target element by the hash

    if (targetElement.length > 0) {
      var headerHeight = $('.header').outerHeight();

      $('html, body').animate({
        scrollTop: targetElement.offset().top - headerHeight + 1
      }, 400); // Duration in milliseconds
    }
  }
});
